/** @jsx jsx */
import { jsx } from '@emotion/core';
import classNames from 'classnames';
import { FieldTextAreaProps, FieldTextAreaWithReduxProps } from './types';

import fieldStyles from '../Field/styles.sass';
import styles from './styles.sass';

const FieldTextAreaWithRedux = ({
  input: { name, onChange, value },
  meta: { error, submitFailed, valid },
  maxLength,
  className,
  placeholderText,
  rows,
  cssProp,
}: FieldTextAreaWithReduxProps) => (
  <FieldTextArea
    rows={rows}
    name={name}
    value={value}
    onChange={onChange}
    isShowingError={submitFailed && !valid}
    error={error}
    maxLength={maxLength}
    className={className}
    placeholderText={placeholderText}
    cssProp={cssProp}
  />
);

const FieldTextArea = ({
  value,
  name,
  onChange,
  onBlur,
  maxLength,
  isShowingError,
  error,
  className,
  placeholderText,
  rows = 12,
  cssProp,
}: FieldTextAreaProps) => (
  <div
    className={classNames(styles.container, {
      [className as string]: !!className,
    })}
    css={cssProp}
  >
    <textarea
      className={classNames(fieldStyles.input, styles.textarea, {
        [fieldStyles.inputError]: isShowingError,
      })}
      rows={rows}
      name={name}
      id={name}
      data-cy={name}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      placeholder={placeholderText}
      maxLength={maxLength}
    />
    <div className={fieldStyles.fieldMetaSection}>
      <div
        className={classNames({
          [fieldStyles.errorWrapper]: true,
          [fieldStyles.errorWrapperVisible]: isShowingError,
        })}
      >
        <span className={fieldStyles.errorText}>{error}</span>
      </div>
      {maxLength && (
        <div className={styles.characterCount}>
          {value.length} / {maxLength}
        </div>
      )}
    </div>
  </div>
);

FieldTextArea.defaultProps = {
  value: '',
};

export { FieldTextArea, FieldTextAreaWithRedux };
